<body>
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <span id="headerText">Plants Gallery</span>
            </div>
        </div>
        <hr><br>
        <!-- <div class="row">
            <div class="col-sm-12">
                <img src="assets/plantspot.png" style="margin:auto;width:100%;height:100%"> 
            </div>
        </div> -->
        <!-- style="margin-top:50px" -->
        <div class="row">
            <div class="col-sm-2">
                <div class="card index-card" (click)="openDialog()">
                    <img src="assets/on-the-shop/crinum002.jpg" class="index-photo"> 
                    <button class="index-button bgc-default" mat-button>
                        Golden Crinum Lily
                    </button>
                </div>
            </div>
            <div class="col-sm-2">
                <div class="card index-card" (click)="openDialog()">
                    <img src="assets/on-the-shop/palmera001.jpg" class="index-photo"> 
                    <button class="index-button bgc-default" mat-button (click)="openDialog()">
                        Palmera
                    </button>
                </div>
            </div>
            <div class="col-sm-2">
                <div class="card index-card" (click)="openDialog()">
                    <img src="assets/on-the-shop/goldencane003.jpg" class="index-photo"> 
                <button class="index-button bgc-default" mat-button (click)="openDialog()">
                    Golden Cane Palm
                </button>
                </div>
            </div>
            <div class="col-sm-2">
                <div class="card index-card" (click)="openDialog()">
                    <img src="assets/on-the-shop/fishtail002.jpg" class="index-photo"> 
                    <button class="index-button bgc-default" mat-button (click)="openDialog()">
                        Fishtail Fern
                    </button>
                </div>
            </div>
            <div class="col-sm-2">
                <div class="card index-card" (click)="openDialog()">
                    <img src="assets/on-the-shop/peruvian002.jpg" class="index-photo"> 
                    <button class="index-button bgc-default" mat-button (click)="openDialog()">
                        Peruvian Fern
                    </button>
                </div>
            </div>
            <div class="col-sm-2">
                <div class="card index-card" (click)="openDialog()">
                    <img src="assets/on-the-shop/pothos001.jpg" class="index-photo"> 
                    <button class="index-button bgc-default" mat-button (click)="openDialog()">
                        Golden Pothos
                    </button>
                </div>
            </div>
        </div>
        <div class="row" style="margin-top:50px" (click)="openDialog()">
            <div class="col-sm-2">
                <div class="card index-card">
                    <img src="assets/on-the-shop/orlando.jpg" class="index-photo"> 
                    <button class="index-button bgc-default" mat-button (click)="openDialog()">
                        Philo Orlando
                    </button>
                </div>
            </div>
            <div class="col-sm-2">
                <div class="card index-card" (click)="openDialog()">
                    <img src="assets/on-the-shop/rostrata.jpg" class="index-photo"> 
                    <button class="index-button bgc-default" mat-button (click)="openDialog()">
                        Heliconia Rostrata
                    </button>
                </div>
            </div>
            <div class="col-sm-2">
                <div class="card index-card" (click)="openDialog()">
                    <img src="assets/on-the-shop/katuray001.jpg" class="index-photo"> 
                <button class="index-button bgc-default" mat-button (click)="openDialog()">
                    Katuray
                </button>
                </div>
            </div>
            <div class="col-sm-2">
                <div class="card index-card" (click)="openDialog()">
                    <img src="assets/on-the-shop/punicium001.jpg" class="index-photo"> 
                    <button class="index-button bgc-default" mat-button (click)="openDialog()">
                        Amaryllis Punicium
                    </button>
                </div>
            </div>
            <div class="col-sm-2">
                <div class="card index-card" (click)="openDialog()">
                    <img src="assets/on-the-shop/forgetmn001.jpg" class="index-photo"> 
                    <button class="index-button bgc-default" mat-button (click)="openDialog()">
                        Forget Me Not
                    </button>
                </div>
            </div>
            <div class="col-sm-2">
                <div class="card index-card" (click)="openDialog()">
                    <img src="assets/on-the-shop/ribbon001.jpg" class="index-photo"> 
                    <button class="index-button bgc-default" mat-button (click)="openDialog()">
                        Ribbon Grass
                    </button>
                </div>
            </div>
        </div>
        <div class="row" style="margin-top:50px" (click)="openDialog()">
            <div class="col-sm-2">
                <div class="card index-card">
                    <img src="assets/on-the-shop/andromeda001.jpg" class="index-photo"> 
                    <button class="index-button bgc-default" mat-button (click)="openDialog()">
                        Andromeda
                    </button>
                </div>
            </div>
            <div class="col-sm-2">
                <div class="card index-card" (click)="openDialog()">
                    <img src="assets/on-the-shop/ladydi001.jpg" class="index-photo"> 
                    <button class="index-button bgc-default" mat-button (click)="openDialog()">
                        Lady di
                    </button>
                </div>
            </div>
            <div class="col-sm-2">
                <div class="card index-card" (click)="openDialog()">
                    <img src="assets/on-the-shop/lutea002.jpg" class="index-photo"> 
                <button class="index-button bgc-default" mat-button (click)="openDialog()">
                    Calathea Lutea
                </button>
                </div>
            </div>
            <div class="col-sm-2">
                <div class="card index-card" (click)="openDialog()">
                    <img src="assets/on-the-shop/asiaticum001.jpg" class="index-photo"> 
                    <button class="index-button bgc-default" mat-button (click)="openDialog()">
                        Summer Sunset
                    </button>
                </div>
            </div>
            <div class="col-sm-2">
                <div class="card index-card" (click)="openDialog()">
                    <img src="assets/on-the-shop/vittata001.jpg" class="index-photo"> 
                    <button class="index-button bgc-default" mat-button (click)="openDialog()">
                        Alpinia Vittata
                    </button>
                </div>
            </div>
            <div class="col-sm-2">
                <div class="card index-card" (click)="openDialog()">
                    <img src="assets/on-the-shop/zigzag001.jpg" class="index-photo"> 
                    <button class="index-button bgc-default" mat-button (click)="openDialog()">
                        Zigzag
                    </button>
                </div>
            </div>
        </div>
    </div>
</body>